export default __webpack_public_path__ + "static/media/Moderat - Rusty Nails.0692546c.mp3";